<template>
  <div
    @click="readNoti()"
    class="flex-display ai-center pd-b-4 pd-t-4 border-b width-80 custom-noti"
    :title="!courseId?`หลักสูตรนี้ไม่มีในระบบ`:null"
    :class="!courseId?'cursor-not-allowed':'cursor-pointer'"
  >
    <i
      class="fas fa-circle"
      :class="readed ? 'color-gray-lighter' : 'color-warning'"
    ></i>
    <div :class="!courseId?'cursor-not-allowed':'cursor-pointer'" class="box-image square mg-l-4">
      <avatar
        :rounded="false"
        :username="image"
        :src="`${gerUrlImageCourse(courseId, image)}`"
        :size="65"
      >
      </avatar>
    </div>
    <div class="flex-display js-between ai-center pd-b-4 width-100 noflex">
      <p class="text-font-16 pd-l-4">
        {{ message }}
      </p>
      <div>
        <a :class="!courseId?'cursor-not-allowed':'cursor-pointer'" class="color-gray text-font-14 pd-l-4 text-style-italic">{{ date }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  components: {
    Avatar,
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    image: {
      type: String,
      default() {
        return "";
      },
    },
    message: {
      type: String,
      default() {
        return "";
      },
    },
    date: {
      type: String,
      default() {
        return "";
      },
    },
    readed: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
    };
  },
  methods: {
    gerUrlImageCourse(id, image) {
      if (this.image != "") {
        return `${this.urlCouse}${id}/${image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    readNoti() {
      if (this.courseId) {
        this.$router.push(`/course/detail?courseId=${this.courseId}`);
      }
      
      this.$emit("readNotification", this.id);
    },
  },
};
</script>
